import React, { memo } from 'react';
import styled from 'styled-components';
import { PrimaryButton } from '../../../components/Buttons';

import FlatButton from '../../../components/Buttons/FlatButton';

const Wrapper = styled.div`
  padding-top: 20px;
  padding-bottom: 40px;
`;
const TitleWrapper = styled.div`
  padding-top: 20px;
  padding-bottom: 40px;
  text-align: center;
  font-size: 20px;
  font-weight: 600;
`;

const MessageWrapper = styled.div`
  padding: 0 16px;
  margin-bottom: 15px;
  text-align: center;
`;
const LinkCard = styled(PrimaryButton)`
  padding: 19px 16px 19px 24px;
  font-size: 19px;
  font-weight: 600;
  text-transform: uppercase;
  &:hover {
    transition: all 0.25s ease;
  }
`;

const NewCardButton = styled(FlatButton)`
  padding: 8px 16px;
  font-size: 19px;
  font-weight: 600;
  text-transform: uppercase;
  margin-top: 20px;
  border: 1px solid #000;
  border-radius: 5px;
  min-width: 280px;
  &:hover {
    transition: all 0.25s ease;
  }
`;
const ActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
`;

export const LoyaltyTransferBalanceSubmit = memo(
  ({ handleCloseModal, handleTransferBalance, loyaltyPayload }) => {
    const { loyalty_number } = loyaltyPayload;
    const endDigits = loyalty_number.replaceAll(' ', '').slice(-4);
    return (
      <Wrapper>
        <MessageWrapper>
          {`The balance of gift card ending with ${endDigits} will be transferred to your Burrito
          Boyz account. After this transfer, your physical gift card will no
          longer be active or useable.`}
        </MessageWrapper>
        <ActionWrapper>
          <LinkCard
            id='ExistingGiftCard-AddGiftCard'
            onClick={() => {
              handleTransferBalance();
            }}
          >
            Transfer Balance
          </LinkCard>
          <NewCardButton
            id='ExistingGiftCard-AddGiftCard'
            type='submit'
            onClick={() => {
              handleCloseModal();
            }}
          >
            Cancel
          </NewCardButton>
        </ActionWrapper>
      </Wrapper>
    );
  }
);
